import React, { useEffect, useState } from "react";
import Banner from "./Banner";
import Categories from "./Categories";
import Navbar from "../Navbar";
import bannerimg from "../../assets/images/banner2.png";
import CaptureImage from "../footer/Footer";
import Testimonials from "./Testimonials";
import Footer from "../footer/Footer";
import { baseURLProd } from "../../api";
import { toast, ToastContainer } from "react-toastify";
const Home = () => {
  // const [classDetails, setClassDetails] = useState([]);
  // const [showPopup, setShowPopup] = useState(false);

  // const handlePopupCancel = () => {
  //   setShowPopup(false);
  // };
  // useEffect(() => {
  //   const showPopupFlag = localStorage.getItem("showAttendancePopup");
  //   if (showPopupFlag === "true") {
  //     fetchPreviousAttendance();
  //   }
  // }, []);

  // const fetchPreviousAttendance = async () => {
  //   const userId = localStorage.getItem("userId");

  //   const attendanceFlag = localStorage.getItem("stopAttendanceCheck");
  //   if (attendanceFlag === "true") return;

  //   try {
  //     const response = await fetch(`${baseURLProd}previous-attendance`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ user_id: userId }),
  //     });

  //     const data = await response.json();

  //     if (data.class_detail?.length) {
  //       setClassDetails(data.class_detail);
  //       setShowPopup(true);
  //       localStorage.removeItem("showAttendancePopup");
  //       localStorage.removeItem("stopAttendanceCheck")
  //     }
  //   } catch (error) {
  //     console.error("Error fetching previous attendance:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchPreviousAttendance();
  // }, []);

  // const markAttendance = async (scheduleId, center, type, isMark) => {
  //   const userId = localStorage.getItem("userId");

  //   try {
  //     const response = await fetch(`${baseURLProd}backup-attendance`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         schedule_id: scheduleId,
  //         center,
  //         type,
  //         user_id: userId,
  //         is_mark: isMark,
  //       }),
  //     });

  //     const data = await response.json();

  //     if (data.status === true) {
  //       toast.success('Attendance Marked Successfully!');
  //       setClassDetails((prevDetails) =>
  //         prevDetails.filter((item) => item.schedule_id !== scheduleId)
  //       );

  //       if (classDetails.length === 1) {
  //         toast.success("All attendance marked Successfully");
  //         window.location.reload();
  //       }
  //     } else {
  //       alert("Failed to mark attendance: " + data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error marking attendance:", error);
  //   }
  // };

  return (
    <div>
      <ToastContainer />
      {/* {showPopup && (
        <div>
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1040,
            }}
          ></div>
          <div
            className="modal fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header d-flex justify-content-end">
                  <h5 className="modal-title"></h5>
                </div>
                <div className="modal-body ">
                  <h6 className="fw text-center">
                    Are you sure you want to mark your attendance?
                  </h6>
                  {classDetails.map((item) => (
                    <div key={item.schedule_id} className="class-item my-4">
                      <div className="d-flex justify-content-between">
                        <div>
                          <b>
                            <p>Date:</p>
                          </b>
                        </div>
                        <div>
                          <p> {item.date}</p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div>
                          <b>
                            <p>Time:</p>
                          </b>
                        </div>
                        <div>
                          <p> {item.time}</p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div>
                          <b>
                            <p>Topics:</p>
                          </b>
                        </div>
                        <div>
                          <p> {item.topic}</p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-around">
                        <div>
                          <button
                            className="absentBtn"
                            onClick={() =>
                              markAttendance(
                                item.schedule_id,
                                item.center,
                                item.type,
                                0
                              )
                            }
                          >
                            Absent
                          </button>
                        </div>
                        <div>
                          <button
                            className="presentBtn"
                            onClick={() =>
                              markAttendance(
                                item.schedule_id,
                                item.center,
                                item.type,
                                1
                              )
                            }
                          >
                            Present
                          </button>
                        </div>
                      </div>
                      <div><hr /></div>

                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}
      <Navbar />
      <Categories />
      <Footer />
    </div>
  );
};

export default Home;
